import { useState, useEffect } from 'react';

export const PWAInstallGuide = () => {
  const [show, setShow] = useState(false);
  const [platform, setPlatform] = useState<'ios' | 'mac' | null>(null);

  useEffect(() => {
    // Détecter iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    
    // Détecter Mac (Safari) - si pas déjà installé
    const isMac = /Macintosh/.test(navigator.userAgent) && !isIOS;
    
    // Vérifier si déjà en mode standalone
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                         (window.navigator as any).standalone === true;

    if (!isStandalone) {
      if (isIOS) {
        setPlatform('ios');
        const hidden = localStorage.getItem('pwa_guide_hidden');
        if (!hidden) setShow(true);
      } else if (isMac) {
        setPlatform('mac');
        const hidden = localStorage.getItem('pwa_guide_hidden');
        if (!hidden) setShow(true);
      }
    }
  }, []);

  if (!show || !platform) return null;

  return (
    <div className="fixed top-4 left-4 right-4 z-[200] animate-in slide-in-from-top duration-500">
      <div className="bg-white rounded-2xl shadow-2xl border border-foret-100 p-4 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-2 h-full bg-foret-600"></div>
        
        <button 
          onClick={() => {
            setShow(false);
            localStorage.setItem('pwa_guide_hidden', 'true');
          }}
          title="Fermer le guide"
          className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600"
        >
          <i className="ri-close-line text-xl"></i>
        </button>

        <div className="flex items-start gap-4 pr-6">
          <div className="w-12 h-12 bg-foret-50 rounded-xl flex items-center justify-center flex-shrink-0 text-foret-600">
            <i className={platform === 'ios' ? "ri-smartphone-line text-2xl" : "ri-macbook-line text-2xl"}></i>
          </div>
          
          <div>
            <h4 className="font-bold text-gray-900 text-sm mb-1">
              Installer l'application Bassoum
            </h4>
            <p className="text-xs text-gray-500 leading-relaxed">
              {platform === 'ios' ? (
                <>
                  Cliquez sur le bouton <span className="inline-flex items-center px-1.5 py-0.5 bg-gray-100 rounded text-gray-700 italic"><i className="ri-share-box-line mr-1"></i>Partager</span> au bas de l'écran, puis sélectionnez <span className="font-bold text-foret-700">"Sur l'écran d'accueil"</span>.
                </>
              ) : (
                <>
                  Dans Safari, allez dans le menu <span className="font-bold">Fichier</span> puis sélectionnez <span className="font-bold text-foret-700">"Ajouter au Dock"</span> pour une expérience optimale.
                </>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
